import React from "react";
import AustriaReqMain from "./AustriaReqMain";
import "./../../UaeAttestation/UaeReq/UaeReq.css";

const AustriaReq = () => {
  return (
    <div className="uaeReqContainer">
      <AustriaReqMain />
    </div>
  );
};

export default AustriaReq;
